/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForVirtualMachinesAgents extends models.BackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForVirtualMachinesAgents");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForVirtualMachinesAgents.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForVirtualMachinesAgents>): BackgroundJobPayloadForVirtualMachinesAgents {
        let obj = Object.assign(new BackgroundJobPayloadForVirtualMachinesAgents(), model);
        BackgroundJobPayloadForVirtualMachinesAgents.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForVirtualMachinesAgents>): BackgroundJobPayloadForVirtualMachinesAgents {
        if (!model) return null;
        return BackgroundJobPayloadForVirtualMachinesAgents.newInstance(<BackgroundJobPayloadForVirtualMachinesAgents> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForVirtualMachinesAgents) {
        if (!obj) return;

        models.BackgroundJobPayloadForVirtualMachinesAgents.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForVirtualMachinesAgents): boolean {
        if (models.BackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForVirtualMachinesAgents.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Service Account ID that needs to processed
     */
    service_account_id: string;

}
